import type React from 'react';

import LabelValueList, { type LabelValue } from '@components/shared/labelValueList';
import { useGetResources } from '@hooks/useGetResources';
import { LagtTilAvType, type MittVerktoyItem } from '@src/types/minhelseentities';

import { shortDateNumbers } from '@helsenorge/core-utils/date-fns-utils';

interface VerktoyMetaInfoMineVerktoyProps {
  mittVerktoy: MittVerktoyItem;
}

const formatDisplayDate = (dateString?: string): string => {
  if (!dateString) {
    return '';
  }
  return shortDateNumbers(new Date(dateString));
};

const createMetaInfoItemsMineVerktoy = (mittVertoyItem: MittVerktoyItem, resources: ReturnType<typeof useGetResources>): LabelValue[] => {
  const opprettetDato = formatDisplayDate(mittVertoyItem.LagtTilDato ?? undefined);

  const lagtTilAvType = mittVertoyItem.LagtTilAvTypeId;

  if (lagtTilAvType === LagtTilAvType.InnbyggerSelv) {
    const label = resources?.mineverktoy_lagt_til_av_label;
    const value = `${resources?.verktoy_lagt_til_av_deg} ${opprettetDato}`;
    return [{ label, value }];
  }

  if (lagtTilAvType === LagtTilAvType.Representant) {
    const label = resources?.mineverktoy_lagt_til_av_label;
    const value = `${mittVertoyItem.LagtTilAv}, ${opprettetDato}`;
    return [{ label, value }];
  }

  const items: LabelValue[] = [];
  if (mittVertoyItem.Begrunnelse) {
    items.push({
      label: resources?.verktoy_begrunnelse_label ?? '',
      value: mittVertoyItem.Begrunnelse,
    });
  }

  if (mittVertoyItem.LagtTilAv) {
    const value = `${mittVertoyItem.LagtTilAv}, ${opprettetDato}`;
    items.push({
      label: resources?.mottatt_fra_label ?? '',
      value,
    });
  }

  return items;
};

const VerktoyMetaInfoMineVerktoy: React.FC<VerktoyMetaInfoMineVerktoyProps> = ({ mittVerktoy }) => {
  const resources = useGetResources();
  const items = createMetaInfoItemsMineVerktoy(mittVerktoy, resources);
  if (items.length === 0) {
    return null;
  }
  return <LabelValueList items={items} />;
};

export default VerktoyMetaInfoMineVerktoy;
